const config = require('../config.js');
const coins = require(`./coins-${config.blockchainId}.js`);
const { arrayToHashmap } = require('../../utils/Array');
const REFERENCE_ASSETS = require('../reference-assets.json');

const FIAT_ASSET_TYPES = [
    REFERENCE_ASSETS.USD,
    REFERENCE_ASSETS.EUR,
];

const defaultCoinTemplate = {
    id: undefined,
    type: undefined,
    symbol: undefined,
    decimals: undefined,
    address: undefined,
    isSynth: false,
    isLpToken: false,
    wrappedCoinType: null,
};

const augmentedCoins = arrayToHashmap(Array.from(Object.entries(coins)).map(([id, coin]) => [id, {
    ...defaultCoinTemplate,
    ...coin,
    get isWrappedCoin() {
        return this.wrappedCoinType !== null;
    },
    get isFiat() {
        return FIAT_ASSET_TYPES.includes(this.type);
    },
    get getCoingeckoId() {
        return this.coingeckoId || this.id;
    },
}]));

const coinsProxy = new Proxy(augmentedCoins, {
    get: function(target, name) {
        if (
            typeof name === 'string' &&
            !(name in target) &&
            name !== 'inspect' &&
            name !== 'state' &&
            name !== 'render' &&
            !name.startsWith('_') // Ignore "private" props
        ) {
            throw new Error(`Property "${name}" not found on object "coins"`);
        }

        return target[name];
    },
});

console.log({ coinsProxy });

module.exports = coinsProxy;
